<template>
    <AppModal ref="modal" :title="$t('labels.deleteProducts')" @on-hide="hide">
        <div class="modal-body">
            <template v-if="task.state.isRunning">
                <TaskProgressBar :done="task.state.done" :total="task.state.total"/>
            </template>
            <template v-else>
                {{ $t('alerts.delete_selected_products', {count: selectedProductUuids.length}) }}
            </template>
        </div>
        <div class="modal-footer" v-if="!task.state.isRunning">
            <AppButton color="light" @click="hide()">{{ $t('buttons.no') }}</AppButton>
            <AppButton color="danger" @click="deleteSelectedProducts()">{{ $t('buttons.yes') }}</AppButton>
        </div>
    </AppModal>
</template>
<script>
import AppModal from '../../../../../components/new/modal/AppModal.vue';
import AppButton from '../../../../../components/new/button/AppButton.vue';
import TaskProgressBar from '../../../../../components/new/progress/TaskProgressBar.vue';

import HttpRequest from '../../../../../services/Http/HttpRequest';
import HttpSender from '../../../../../services/Http/HttpSender';
import { createProgressTask } from '../../../../../services/Progress/ProgressTask';

export default {
    name: "DeleteProductsModal",
    components: {
        AppModal, AppButton, TaskProgressBar
    },
    emits: ['products:deleted'],
    props: {
        order: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            task: createProgressTask(),
            selectedProductUuids: []
        }
    },
    methods: {
        show(selectedProductUuids) {
            this.selectedProductUuids = selectedProductUuids;
            this.$refs.modal.show();
        },
        hide() {
            this.task.cancel();
            this.$refs.modal.hide();
            this.selectedProductUuids = [];
        },
        async deleteSelectedProducts() {
            const requests = this.selectedProductUuids.map(
                uuid => new HttpRequest('DELETE', `/projects/${this.$route.params.projectUuid}/crm/orders/${this.order.uuid}/products/${uuid}`),
            );

            let finished = true;

            try {
                finished = await this.task.run(async ({setTotal, tick}) => {
                    setTotal(requests.length);

                    await new HttpSender().sendRequestsInBatches(requests, () => tick());
                });
            } catch (error) {}

            if (!finished) {
                return;
            }

            this.hide();
            this.$emit('products:deleted');
        }
    },
    beforeUnmount() {
        this.task.cancel();
    }
}
</script>